import classNames from 'classnames';
import type { FC, MouseEvent } from 'react';
import React, { useRef, useState } from 'react';

import type { TInput } from './models';

export const IconInput: FC<TInput> = ({
    IconButton,
    IconCross,
    Text,
    autoComplete = 'on',
    autoCompletePlaceholder,
    browserAutoComplete = 'on',
    className,
    hideSearchCross = true,
    innerRef,
    onClose,
    styles,
    ...rest
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const ref = useRef<HTMLInputElement>(null);

    const onResetInput = (event: MouseEvent) => {
        if (onClose) {
            onClose(event);
        } else {
            const currentRef = innerRef ?? ref;
            /* istanbul ignore else */
            if (currentRef?.current) {
                currentRef.current.value = '';

                return;
            }
        }
    };

    const isViewCross = !hideSearchCross && (isFocused || isHovered);

    const onFocus = () => {
        setIsFocused(true);
    };

    const onBlur = () => {
        setIsFocused(false);
    };

    const onMouseEnter = () => {
        setIsHovered(true);
    };

    const onMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div className={styles.wrapper}>
            {autoCompletePlaceholder && (
                <Text
                    className={classNames(styles.external, styles.autoCompletePlaceholder)}
                    tag="span"
                >
                    {autoCompletePlaceholder}
                </Text>
            )}
            <div
                className={styles.inputWrapper}
                onBlur={onBlur}
                onFocus={onFocus}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <input
                    ref={innerRef || ref}
                    autoComplete={browserAutoComplete || autoComplete}
                    className={classNames(styles.input, className, styles.noCross)}
                    {...rest}
                />
                {isViewCross && (
                    <IconButton
                        aria-label="очистить"
                        className={classNames(styles.crossButton, styles.external)}
                        data-test-id="icon-input-cross"
                        onClick={onResetInput}
                        onMouseDown={(event: MouseEvent) => event.preventDefault()}
                        type="button"
                    >
                        <IconCross className={classNames(styles.inputCross, styles.external)} />
                    </IconButton>
                )}
            </div>
        </div>
    );
};
